
// Imports Images 
import quickConvoImage from '../images/QUICKCONVO.png';
import studentManagementImage from '../images/SMS.png';
import newsStreamImage from '../images/NewsStream.png';
import movieRatingImage from '../images/Movie-Rating.png';
import weatherForecastImage from '../images/Weather.png';
import netflixCloneImage from '../images/Netflix-clone.png';
import toDoImage from '../images/To-Do.png';
import eBazaarImage from '../images/E-Bazaar.png';
import cabBookingImage from '../images/Cab-Web.png';
import contextShoppingImage from '../images/Context-Shopping-App.png';
import entertainmentMelaImage from '../images/The-Entertainment-Mela.png';
import freelancerImage from '../images/FREELANCER.png';
import VikasImage from '../images/profilepic.png';
import quizyfyImage from '../images/quizyfy.png';
import logix from '../images/Logix.png';
import subsImage from '../images/SV-Subscription.png';
import VoiceScript from '../images/VoiceScript.png';
import TTB from '../images/TTB-logo.jpg';
import Gilbert from '../images/gilbert.png';

export const Bio = {
  name: "Vikas Saxena",
  roles: [
    "Frontend Developer",
    "Web Developer",
    "Software Engineer",
    "Technical Support Engineer",
    "Application Support Engineer",
    "Web Operations Professional",
  ],
  image: VikasImage,
 description:
  "Computer Science Engineering graduate with experience in React.js, JavaScript, MERN Stack, web operations, technical support, and application troubleshooting. Passionate about building responsive web applications, solving technical challenges, and delivering reliable user-focused solutions.",
  github: "https://github.com/VikasSaxena2204",
  resume: "https://drive.google.com/file/d/18k_x1ukb7y3LesH0SZ3M14RaEQL91OOW/view?usp=sharing", 
  linkedin: "https://www.linkedin.com/in/2204-vikas-saxena/",
  twitter: null, 
  insta: null, 
  facebook: null, 
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Tailwind CSS",
        image:
          "https://icon.icepanel.io/Technology/svg/Tailwind-CSS.svg"
        },
      {
        name: "Python",
        image:
          "https://s3.dualstack.us-east-2.amazonaws.com/pythondotorg-assets/media/community/logos/python-logo-only.png"
        },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Express",
        image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSnDneBGnQL7E9hZDwztRO1GfQcCj1FqRrhBw&s",
      },
    ],
  },
  {
    title: "Others",
    skills: [
  
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Vercel",
        image:
          "https://assets.vercel.com/image/upload/v1588805858/repositories/vercel/logo.png" 
        },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
    ],
  },
];

export const experiences = [
  {
    id: 4,
img: TTB,
role: "Web Operations Associate",
company: "Top Talent Bridge",
date: "Jan 2025 - Present",
desc: "Managing website updates, frontend enhancements, content publishing, landing page maintenance, and technical troubleshooting across company and client websites. Working with WordPress, HTML, CSS, JavaScript, and AI-enabled tools to improve workflows, user experience, and operational efficiency while collaborating with cross-functional teams.",
skills: [
"Web Operations",
"WordPress",
"JavaScript",
"HTML",
"CSS",
"Technical Support",
"Troubleshooting",
"Documentation",
"Responsive Web Design",
"Cross-Functional Collaboration"
],
    doc: "",
  },
  {
    id: 3,
img: Gilbert,
role: "Data Science & Machine Learning Intern",
company: "Gilbert Research Center (Remote)",
date: "Dec 2024 - May 2025",
desc: "Completed structured training in Data Science, Machine Learning, Statistics, and Probability through guided learning modules and practical exercises. Gained hands-on exposure to Python, data preprocessing, basic data analysis, and introductory machine learning concepts while exploring AI workflows and Large Language Models (LLMs).",
skills: [
"Python",
"Data Science",
"Machine Learning",
"Statistics",
"Probability",
"Data Analysis",
"Artificial Intelligence",
"Research"
],

    doc: "",
  },
  {
   id: 0,
img: "",
role: "Web Developer",
company: "BharatTech Intenz",
date: "Feb 2024 - Jan 2025",
desc: "Developed responsive web pages and user interface components using React.js, JavaScript, HTML5, and CSS3. Worked on frontend features, responsive layouts, testing, debugging, and cross-browser compatibility while collaborating with team members using Git and GitHub.",
skills: [
"React.js",
"JavaScript",
"HTML5",
"CSS3",
"Frontend Development",
"Responsive Web Design",
"Git",
"GitHub",
"Debugging"
],
    doc: "",
  },
  {
    id: 1,
img: "",
role: "Frontend Developer Trainee",
company: "Supero Software Pvt. Ltd.",
date: "Jul 2022 - Mar 2023",
desc: "Developed reusable user interface components using React.js, JavaScript, HTML, and CSS. Converted design mockups into responsive web pages, assisted in testing and debugging frontend issues, and collaborated with senior developers on feature enhancements and UI improvements.",
skills: [
"React.js",
"JavaScript",
"HTML",
"CSS",
"Frontend Development",
"Responsive Web Design",
"UI Development",
"Debugging"
],
  },
];

export const education = [
{
id: 0,
img: "https://jcboseust.ac.in/assets/uploads/media/be5cb2dc7f8445c5b3dc7d814be25bc9.png",
school: "J.C. Bose University of Science and Technology, YMCA",
date: "Jul 2018 - May 2022",
grade: "CGPA: 8.76",
desc: "Completed a Bachelor's degree in Computer Science & Engineering with a strong foundation in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, Computer Networks, and Software Development.",
degree: "Bachelor of Technology (B.Tech), Computer Science & Engineering",
},
{
id: 1,
img: "https://bseh.org.in/logo.png",
school: "K.D. Senior Secondary School, Faridabad",
date: "2016 - 2018",
grade: "86.8%",
desc: "Completed Senior Secondary Education with Science and Computer Science, building a foundation in mathematics, analytical thinking, and technology.",
degree: "Class XII (HBSE) - Science",
},
{
id: 2,
img: "https://bseh.org.in/logo.png",
school: "Saint Micah Christian High School, Faridabad",
date: "2015 - 2016",
grade: "90.4%",
desc: "Completed Secondary Education with strong academic performance and active participation in school activities.",
degree: "Class X (HBSE)",
},
];

export const projects = [

  {
    id: 15,
    title: "VoiceScript",
    date: "Dec 2024",
    description: "VoiceScript is an easy-to-use, web-based Speech-to-Text converter that allows users to speak into their device's microphone and have their speech transcribed into text in real-time.",
    image: VoiceScript,
    tags: ["JavaScript", "CSS", "HTML", "Speech-to-Text"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/VoiceScript",
    webapp: "https://vikassaxena2204.github.io/VoiceScript/",
  },  
  {
    id: 14,
    title: "Subscription-Vault",
    date: "Dec 2024",
    description: "Subscription-Vault is a web application that manage and track your subscriptions effectively. The app provides features like adding subscriptions, viewing a subscription list, and generating a revenue report.",
    image: subsImage,
    tags: ["React Js", "Tailwind CSS", "Node Js", "Express Js", "JSON Server", "JSON API", "React Icons"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Subscription-Vault",
    webapp: "https://subscription-vault.vercel.app/",
  },
   {
    id: 13,
    title: "Logix App",
    date: "Nov 2024",
    description: "Logix is a responsive and dynamic application built using the MERN stack (MongoDB, Express.js, React.js, and Node.js). Designed to showcase robust authentication workflows, Logix features intuitive user registration, login functionality, and a modern dashboard interface.",
    image: logix,
    tags: ["React Js", "Node Js", "Express.js", "MongoDB", "JWT", "CSS3", "JavaScript"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Logix-frontend",
    webapp: "https://logix-frontend.vercel.app/",
  },
   {
    id: 12,
    title: "Quizyfy App",
    date: "Nov 2024",
    description: "Quizyfy is an interactive quiz app built with React.js, offering users a fun and participating in quiz experience.",
    image: quizyfyImage,
    tags: ["React Js", "JavaScript", "Bootstrap", "CSS", "Chakra-UI"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Quizyfy",
    webapp: "https://quizyfy-phi.vercel.app/",
  },
  {
    id: 0,
    title: "Quick-Convo",
    date: "Oct 2024",
    description: "Quick Convo is a full-stack application using MERN technologies, designed to facilitate instant messaging and user conversations.",
    image: quickConvoImage,
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Custom-CSS-Styles"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/QuickConvo-Frontend",
    webapp: "https://quick-convo.vercel.app/",
    member: [
      {
        name: "Vikas Saxena",
        img: VikasImage,
        linkedin: "https://www.linkedin.com/in/2204-vikas-saxena/",
        github: "https://github.com/VikasSaxena2204/",
      },
    ],
  },
  {
    id: 1,
    title: "Student-Management-App",
    date: "Aug 2024",
    description: "Student Management App is a frontend web application designed for efficiently managing student information, featuring an intuitive user interface for easy navigation.",
    image: studentManagementImage,
    tags: ["React.js", "Bootstrap", "Global-Context-API", "React-CRUD"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Student-Management-App",
    webapp: "https://student-management-app-iota.vercel.app/",
  },
 
  {
    id: 2,
    title: "News Stream",
    date: "Sep 2024",
    description: "News Stream is a React-js based news application that delivers real-time news articles from various categories.",
    image: newsStreamImage,
    tags: ["React-Js", "NewsAPI", "CSS-Framework", "JavaScript"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/News-Stream",
    webapp: "https://github.com/VikasSaxena2204/News-Stream",
  },
  {
    id: 3,
    title: "Movie-Rating App",
    date: "Sep 2024",
    description: "Movie-Rating App is a Next.js based application that delivers Movie Templates with descriptions from various categories.",
    image: movieRatingImage,
    tags: ["Next Js", "JavaScript", "Bootstrap", "CSS"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Movie-Rating-Next-App",
    webapp: "https://github.com/VikasSaxena2204/Movie-Rating-Next-App",
  },
  {
    id: 4,
    title: "Weather-Forecast-App",
    date: "Aug 2024",
    description: "Weather Forecast App is an interactive web application that provides real-time weather updates and forecasts.",
    image: weatherForecastImage,
    tags: ["React Js", "Weather-API", "Bootstrap", "CSS"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Weather-Forecast-App",
    webapp: "https://vikassaxena2204.github.io/Weather-Forecast-App/",
  },
  {
    id: 5,
    title: "Netflix-clone",
    date: "Aug 2024",
    description: "A Netflix-clone web app layout page with sign-in and sign-up features. Tech Stack: React.js for frontend, Tailwind CSS for styling, Context API for state management, and Firebase for user database.",
    image: netflixCloneImage,
    tags: ["React Js", "Context-API", "Tailwind CSS", "State Management"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Netflix-Clone",
    webapp: "https://github.com/VikasSaxena2204/Netflix-Clone",
  },
  {
    id: 6,
    title: "To-Do ",
    date: "Aug 2024",
    description: "To-Do List is a practical daily work management tool developed using HTML, CSS, and JavaScript.",
    image: toDoImage,
    tags: ["HTML", "CSS", "JavaScript", "Local-Storage"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/To-Do-List",
    webapp: "https://vikassaxena2204.github.io/To-Do-List/",
  },
  {
    id: 7,
    title: "E-Bazaar ",
    date: "Jul 2024",
    description: "E-Bazaar is a dynamic frontend web page layout crafted with modern frontend technologies.",
    image: eBazaarImage,
    tags: ["React JS", "Tailwind CSS", "Vite", "Global-Context"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/E-Bazaar-Page",
    webapp: "https://vikassaxena2204.github.io/E-Bazaar-Page/",
  },
  {
    id: 8,
    title: "Cab-Booking-Webpage",
    date: "June 2024",
    description: "Cab-Booking is an intuitive frontend web page layout designed with essential web technologies.",
    image: cabBookingImage,
    tags: ["HTML", "CSS", "JavaScript"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Cab-Booking-Webpage",
    webapp: "https://vikassaxena2204.github.io/Cab-Booking-Webpage/",
  },
  {
    id: 9,
    title: "Context-Shopping-App",
    date: "Sep 2024",
    description: "Context-Shopping-App is a user-friendly frontend web page layout crafted with fundamental web technologies.",
    image: contextShoppingImage,
    tags: ["Context API", "React-CRUD", "React JS", "Bootstrap"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/Context-Shopping-App",
    webapp: "https://context-shopping-app.vercel.app/",
  },
  {
    id: 10,
    title: "The-Entertainment-Mela",
    date: "April 2024",
    description: "The-Entertainment-Mela is a vibrant frontend web page layout designed with essential web technologies.",
    image: entertainmentMelaImage,
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/The-Entertainment-Mela",
    webapp: "https://vikassaxena2204.github.io/The-Entertainment-Mela/",
  },
  {
    id: 11,
    title: "FREELANCER",
    date: "April 2022",
    description: "FREELANCER is a sleek and modern frontend web page layout crafted with fundamental web technologies.",
    image: freelancerImage,
    tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
    category: "web app",
    github: "https://github.com/VikasSaxena2204/FREELANCER",
    webapp: "https://vikassaxena2204.github.io/FREELANCER/",
  },
];
